import React from 'react';
import _sharedStylesRaw from './ClubShared.module.css';
const sharedStyles = (typeof _sharedStylesRaw === 'object' && _sharedStylesRaw !== null) ? _sharedStylesRaw : {};
import styles from './ClubLiveStanding.module.css';
import OptimizedImage from '../player/OptimizedImage';

export default function ClubLiveStanding({ teams, variant }) {
    if (!teams || teams.length === 0) return null;

    const getInitials = (name) => {
        if (!name) return '';
        const parts = name.split(' ');
        if (parts.length >= 2) {
            return (parts[0][0] + parts[1][0]).toUpperCase();
        }
        return name.substring(0, 2).toUpperCase();
    };

    const renderLogo = (team) => {
        if (!team.logo) return null;
        return (
            <div className={styles.logoCircle}>
                <OptimizedImage src={team.logo} alt={team.name} width={40} height={40} unoptimized className={styles.logoImg} />
            </div>
        );
    };

    if (variant === 'desktop') {
        return (
            <section className={sharedStyles.section}>
                <h2 className={sharedStyles.sectionTitle}>Live Standings</h2>
                <div className={styles.desktopRows}>
                    {teams.map((team, index) => (
                        <div 
                            key={index} 
                            className={`${styles.standingRow} ${team.isCurrent ? styles.activeRow : ''}`}
                        >
                            <div className={styles.rankBox}>
                                <span className={styles.hash}>#</span>
                                <span className={styles.rankNum}>{team.rank}</span>
                            </div>
                            <div className={styles.teamInfo}>
                                {renderLogo(team)}
                                <span className={styles.name}>{team.name}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </section>
        );
    }

    return (
        <section className={sharedStyles.section}>
            <h2 className={sharedStyles.sectionTitle}>Live Standing</h2>
            <div className={styles.standingTable}>
                <div className={styles.tableHeader}>
                    <span>#</span>
                    <span>Team</span>
                </div>
                <div className={styles.tableBody}>
                    {teams.map((team, index) => (
                        <div 
                            key={index} 
                            className={`${styles.tableRow} ${team.isCurrent ? styles.activeRow : ''}`}
                        >
                            <span className={styles.rank}>{team.rank}</span>
                            <div className={styles.teamNameCell}>
                                {renderLogo(team)}
                                <span className={styles.teamName}>{team.name}</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
